import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { X, Layers } from "lucide-react";
import { useDismissedUIElements } from "@/hooks/useDismissedUIElements";

export function MilestoneSetsEducationalNotice() {
  const { isDismissed, isLoading, dismiss, isDismissing } = useDismissedUIElements(
    'milestone_sets_educational_notice'
  );

  if (isDismissed || isLoading) {
    return null;
  }

  return (
    <Card className="bg-blue-50 border-blue-200">
      <CardContent className="p-4">
        <div className="flex items-start gap-3">
          <div className="rounded-full bg-blue-100 p-2">
            <Layers className="h-5 w-5 text-blue-600" />
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-blue-900 mb-1">What are Milestone Sets?</h3>
            <p className="text-sm text-blue-800">
              Milestone Sets are collections of key events in a job's lifecycle. 
              If you have a sequence of events that each job should go through, 
              you can save them as a Milestone Set and easily re-use them across 
              multiple jobs.
            </p>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => dismiss()}
            disabled={isDismissing}
            className="text-blue-700 hover:text-blue-900 hover:bg-blue-100 h-8 w-8 p-0 shrink-0"
            aria-label="Dismiss notice"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
